import { Link } from 'react-router-dom';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      className={'brand' + (compact ? ' brand-compact' : '')}
      to="/"
      aria-label="冰激凌英语营首页"
    >
      <img className="brand-mark" src="/logo.png" width="35" height="35" alt="" />
      <span className="brand-wordmark">
        Mastery<span>+</span>
      </span>
      {!compact && <span className="brand-name">冰激凌英语营</span>}
    </Link>
  );
}
